import { Link } from "react-router-dom";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#090d12] text-neutral-300 border-t border-neutral-800">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {/* Kolonne 1: Brand & Profil */}
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <img
                src="https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/cropped-fyat-logo-1-180x180.png"
                alt="Fyns Afløbsteknik Logo"
                className="h-14 w-14 object-contain brightness-0 invert opacity-75 contrast-125 hover:opacity-95 transition-all duration-200"
                style={{ filter: "brightness(0) invert(0.8) contrast(1.1)" }}
              />
            </div>

            <p className="text-sm text-neutral-400 leading-relaxed">
              Professionel og autoriseret kloakmester på Fyn med speciale i rottesikring, TV-inspektion, højvandslukke og punktreparation uden opgravning.
            </p>

            <div className="pt-2 flex items-center gap-3">
              <a
                href="https://www.facebook.com/people/Fyns-Afl%C3%B8bsteknik/100013505680388"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded bg-neutral-800 hover:bg-neutral-700 text-neutral-300 hover:text-white flex items-center justify-center transition-colors"
                aria-label="Fyns Afløbsteknik på Facebook"
              >
                <i className="fa-brands fa-facebook-f" aria-hidden="true" />
              </a>
            </div>
          </div>

          {/* Kolonne 2: Ydelser */}
          <div>
            <h4 className="text-white font-bold text-base mb-4 tracking-wide flex items-center gap-2">
              <span className="w-1.5 h-4 bg-neutral-400 rounded-full" />
              Ydelser & Områder
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/rottespaerre" className="hover:text-white transition-colors flex items-center gap-2">
                  <i className="fa-solid fa-angle-right text-xs text-neutral-600" aria-hidden="true" />
                  <span>Rottespærre</span>
                </Link>
              </li>
              <li>
                <Link to="/hoejvandslukke" className="hover:text-white transition-colors flex items-center gap-2">
                  <i className="fa-solid fa-angle-right text-xs text-neutral-600" aria-hidden="true" />
                  <span>Højvandslukke</span>
                </Link>
              </li>
              <li>
                <Link to="/kloak-tv" className="hover:text-white transition-colors flex items-center gap-2">
                  <i className="fa-solid fa-angle-right text-xs text-neutral-600" aria-hidden="true" />
                  <span>Kloak TV (Inspektion)</span>
                </Link>
              </li>
              <li>
                <Link to="/punktreparation" className="hover:text-white transition-colors flex items-center gap-2">
                  <i className="fa-solid fa-angle-right text-xs text-neutral-600" aria-hidden="true" />
                  <span>Punktreparation uden opgravning</span>
                </Link>
              </li>
              <li>
                <Link to="/spuling-slamsugning" className="hover:text-white transition-colors flex items-center gap-2">
                  <i className="fa-solid fa-angle-right text-xs text-neutral-600" aria-hidden="true" />
                  <span>Spuling/slamsugning</span>
                </Link>
              </li>
              <li>
                <Link to="/raad-mod-rotter" className="hover:text-white transition-colors flex items-center gap-2">
                  <i className="fa-solid fa-angle-right text-xs text-neutral-600" aria-hidden="true" />
                  <span>Råd Mod Rotter (5 gode råd)</span>
                </Link>
              </li>
              <li>
                <Link to="/om-fyns-afloebsteknik" className="hover:text-white transition-colors flex items-center gap-2">
                  <i className="fa-solid fa-angle-right text-xs text-neutral-600" aria-hidden="true" />
                  <span>Om Fyns Afløbsteknik</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Kolonne 3: Specialer & Certifikation */}
          <div>
            <h4 className="text-white font-bold text-base mb-4 tracking-wide flex items-center gap-2">
              <span className="w-1.5 h-4 bg-neutral-400 rounded-full" />
              Certificering & Speciale
            </h4>
            
            {/* Validan logo */}
            <div className="bg-white p-2.5 rounded mb-3 inline-block shadow-sm">
              <img
                src="/images/validan-logo.svg"
                alt="Validan Kontrolinstans - Godkendt af Sikkerhedsstyrelsen"
                className="h-10 w-auto object-contain"
              />
            </div>
            
            <p className="text-xs text-neutral-400 mb-3">
              Godkendt af Sikkerhedsstyrelsen som kontrolinstans inden for autorisationsområdet kloak.
            </p>

            <ul className="text-xs text-neutral-400 space-y-1.5">
              <li className="flex items-start gap-1.5">
                <i className="fa-solid fa-check text-neutral-400 mt-0.5" aria-hidden="true" />
                <span>Rottesikring af kloaksystemer</span>
              </li>
              <li className="flex items-start gap-1.5">
                <i className="fa-solid fa-check text-neutral-400 mt-0.5" aria-hidden="true" />
                <span>Højvandslukke ved skybrud</span>
              </li>
              <li className="flex items-start gap-1.5">
                <i className="fa-solid fa-check text-neutral-400 mt-0.5" aria-hidden="true" />
                <span>Lovpligtigt serviceeftersyn</span>
              </li>
              <li className="flex items-start gap-1.5">
                <i className="fa-solid fa-check text-neutral-400 mt-0.5" aria-hidden="true" />
                <span>Røgprøvning for utætheder</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-8 border-t border-neutral-800 text-xs text-neutral-500 flex flex-col sm:flex-row items-center justify-between gap-4 text-center sm:text-left">
          <p>© {currentYear} Fyns Afløbsteknik ApS. Alle rettigheder forbeholdes.</p>
          <div className="flex items-center gap-4 text-neutral-400">
            <span>Aut. Kloakmester</span>
            <span>•</span>
            <span>Odense & hele Fyn</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
